// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import MetadataField from './metadata-field';

const Project = {
  id: PropTypes.string,
  name: PropTypes.string,
};

export default class ProjectField extends MetadataField {
  static propTypes = {
    ...MetadataField.propTypes,
    onProjectChange: PropTypes.func.isRequired,
    editing: PropTypes.bool.isRequired,
    projects: PropTypes.arrayOf(PropTypes.shape(Project)).isRequired,
    projectID: PropTypes.string,
  };

  renderEditable() {
    const { styles } = ProjectField;

    return (
      <select
        value={this.selectValue}
        onChange={this.handleSelectChange}
        className={css(styles.select)}
      >
        {this.renderOptions()}
      </select>
    );
  }

  get selectValue() {
    const { projectID } = this.props;

    return projectID || '';
  }

  renderLabelContent() {
    return <strong className={MetadataField.styles.strong}>Project</strong>;
  }

  renderValueContent() {
    return <span>{this.projectLabel}</span>;
  }

  renderOptions() {
    const { projects } = this.props;
    const options = [];

    options.push({ value: '', label: '- No Project -' });

    const sorted = projects.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }

      return 0;
    });

    options.push.apply(options, sorted.map((project) => ({ value: project.id, label: project.name })));

    const result = options.map((option) => (
      <option
        key={option.value}
        value={option.value}
      >
        {option.label}
      </option>
    ));

    return result;
  }

  handleSelectChange = (event) => {
    const projectID = event.target.value.length ? event.target.value : null;

    this.props.onProjectChange(this.findProject(projectID));
  };

  findProject(id: string) {
    const { projects } = this.props;

    // eslint-disable-next-line no-restricted-syntax
    for (const project of projects) {
      if (project.id === id) {
        return project;
      }
    }

    return null;
  }

  get projectLabel() {
    const { projectID } = this.props;
    const project = this.findProject(projectID);

    return project ? project.name : null;
  }
}

const styles = cssInJS({
  select: {
    fontFamily: THEME.fontFamily,
    fontSize: THEME.editFontSize,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    display: 'inline-block',
    padding: 5,
    verticalAlign: 'middle',
    borderRadius: 5,
    width: '100%',
    marginTop: 4,
    marginRight: 0,
    marginBottom: 4,
    marginLeft: 0,
    // '-webkit-appearance': 'none',

    '@phone': {
      width: '100%',
    },
  },
});

ProjectField.styles = styles;
